import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import {
	BasicSelect
} from 'vue-search-select';
import moment from 'moment'
import user_tracker from '../../../../usertracker'
import utils from "../../../../utils/validateScanner"


export default {
	name: 'inscan-shortage-shipment',
	mixins: [utils],
	components: {
		VueElementLoading,
		BasicSelect
	},
	props: [],
	data() {
		return {
			isLoading: false,
			IsShipmentTable: false,
			EmptyList: false,
			checkedType: '',
			bagNo: '',
			shipmentID: '',
			bagStatus: '',
			BagStatusError: '',
			BagStatusList: [],
			status: '',
			ShipmentStatusList: [],
			ShoratgeShipmentList: [],
			ShipmentStatusError: '',
			comments: '',
			hubid: '',
			createdbyemail: '',
			hubName: '',
			ShipmentIDError: '',
			BagNoError: '',
			token: '',
			invalidTokenModal: false,
			invalidtokenmsg: '',
			timeoutHandler: 0,
			inputString:'',
			manualInput:false,
			userData:[]
		}
	},
	computed: {},
	mounted() {
		var userTokenEncrypt = window.localStorage.getItem('userToken')
		var userTokenDecrypt = CryptoJS.AES.decrypt(userTokenEncrypt.toString(), 'Key');
		var userToken = userTokenDecrypt.toString(CryptoJS.enc.Utf8);
		this.token = JSON.parse(userToken)
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext)
		this.userData = userdetail;
		this.hubid = userdetail[0].HubId[0];
		this.createdbyemail = userdetail[0].email;
		this.getLoginHubName(userdetail[0].HubId);
		this.getHubDetailslist(userdetail[0].HubId);
	},
	methods: {
		checkBarcode(e){
			if (this.timeoutHandler) {
      clearTimeout(this.timeoutHandler)
      this.inputString += String.fromCharCode(e.keyCode)
    	}
			this.timeoutHandler = setTimeout(() => {
		 		if (this.inputString.length <= 3) {
			 		this.manualInput = true
			 		this.inputString = ''
		 		}else{
			 		this.manualInput = false
			 		this.inputString = ''
		 		}
	 		}, 10)
 		},

		getLoginHubName(hubid) {
			this.input = {
				hubids: hubid
			}
			axios({
					method: 'POST',
					url: apiUrl.api_url_hubops + 'expose/hubservicecenter/hubarray/get',
					data: this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					if (result.data.ResultCode == 100) {
						this.hubName = result.data.ResponseData[0].HubName;
					} else {
						this.hubName = '';
					}
				}, error => {
					console.error(error)
				})
		},
		selectReason(reasonitem) {
			this.reasonitem = reasonitem
			this.reason = this.reasonitem.text
		},
		logout(e) {
			localStorage.removeItem('permissiondata')
			localStorage.removeItem('userdetail')
			localStorage.removeItem('userToken')
			localStorage.removeItem('isLoggedIn')
			localStorage.removeItem('loginDate')
			this.$router.push('/login')
			e.preventDefault()
		},
		closeinvalidTokenModal() {
			this.invalidTokenModal = false
			this.invalidtokenmsg = ''
		},
		getShoratgeShipmentList() {
			if (this.shipmentID == '') {
				this.manualInput = false
				this.ShipmentIDError = 'The ShipmentID field is required.'
				return false;
			} else {
				this.ShipmentIDError = ''
			}
			var self = this
			this.ShoratgeShipmentList = []
			this.input = {}
			axios({
					method: 'GET',
					url: apiUrl.api_url_hubops + 'getShipmentDetailsForShortage?flow=shortageToInscan&shippingID=' + self.shipmentID+'&CurrentHubID='+this.hubid,
					data: this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25'
					}
				})
				.then((response) => {
					if (response.data.ResultCode == 100) {
						this.ShoratgeShipmentList = response.data.Shipments.result
						this.IsShipmentTable = true
						this.EmptyList = false
						if(Object.keys(response.data.lossCategorization).length !=0){
							this.colorCode = response.data.lossCategorization.colorCode;
              				this.colorIcon = response.data.lossCategorization.icon;
						}

						// this.$alertify.success(response.data.ReturnMessage)
					} else {
						this.EmptyList = true
						this.IsShipmentTable = false
						this.showHideCodeIconInput();
						this.$alertify.error(response.data.ReturnMessage)
					}
				})
				.catch((httpException) => {
					this.showHideCodeIconInput();
					console.error('exception is:::::::::', httpException)
				})
		},
		clearError() {
			if (this.shipmentID == '') {
				this.manualInput = false
				this.ShipmentIDError = 'The ShipmentID field is required.'
			} else {
				this.ShipmentIDError = ''
			}
		},
		markShipment() {
			this.input = {
				"ShippingId": this.shipmentID.trim(),
				"CurrentHubID": this.hubid,
				"LastModifiedBy": this.createdbyemail,
				"isManualEntry": this.manualInput
			}
			axios({
					method: 'POST',
					url: apiUrl.api_url_hubops + 'markShipmentShortageToInscan',
					data: this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
						'requestfrom': "WEB",
						'token': this.token
					}
				})
				.then((response) => {
					if (response.data.ResultCode == 100) {
						this.invalidTokenModal = false
						this.$alertify.success(response.data.ReturnMessage)
					} else if (response.data.ResultCode == 401) {
						this.invalidTokenModal = true
						this.invalidtokenmsg = result.data.ReturnMessage
						this.$alertify.error(result.data.ReturnMessage)
					} else {
						this.invalidTokenModal = false
						this.$alertify.error(response.data.ReturnMessage)
					}
				})
				.catch((httpException) => {
					console.error('exception is:::::::::', httpException)
				})
		},
		clearBagError() {
			if (this.bagNo == '') {
				this.BagNoError = 'The Bag No field is required.'
			} else {
				this.BagNoError = ''
			}
		},
		markBag() {
			if (this.bagNo == '') {
				this.BagNoError = 'The Bag No field is required.'
			} else {
				this.BagNoError = ''
				this.input = {
					"currentHubId": this.hubid,
					"currentHubName": this.hubName,
					"parentBagNo": this.bagNo.trim(),
					"lastModifiedBy": this.createdbyemail
				}
				axios({
						method: 'POST',
						url: apiUrl.api_url_hubops + 'markBagShortageToInscan',
						data: this.input,
						headers: {
							'authorization': 'authkey xB84JJ89Hd25',
							'requestfrom': "WEB",
							'token': this.token
						}
					})
					.then((response) => {
						if (response.data.ResultCode == 100) {
							this.invalidTokenModal = false
							this.$alertify.success(response.data.ReturnMessage)
							if(Object.keys(result.data.lossCategorization).length !=0){
							this.colorCode = result.data.lossCategorization.colorCode;
							this.colorIcon = result.data.lossCategorization.icon;
						}
						} else if (response.data.ResultCode == 401) {
							this.invalidTokenModal = true
							this.invalidtokenmsg = result.data.ReturnMessage
							this.$alertify.error(result.data.ReturnMessage)
							this.showHideCodeIconInput();
						} else {
							this.invalidTokenModal = false
							this.$alertify.error(response.data.ReturnMessage)
							this.showHideCodeIconInput();
						}
							user_tracker.checkUserIP(this.userData[0], "BagOut_InscanShortage", this.$route.path,this.input);
					})
					.catch((httpException) => {
						console.error('exception is:::::::::', httpException)
					})
			}
		},
		clearShipmentForm() {
			this.shipmentID = ''
			this.manualInput = false
			this.checkedType = ''
			this.status = ''
			this.ShipmentStatusError = ''
			this.comments = ''
			this.ShipmentIDError = ''
			this.IsShipmentTable = false
			this.EmptyList = false
			this.ShoratgeShipmentList = []
			this.showHideCodeIconInput();
		},
		clearBagForm() {
			this.bagNo = ''
			this.checkedType = ''
			this.bagStatus = ''
			this.BagStatusError = ''
			this.BagNoError = ''
			this.showHideCodeIconInput();
		},
		checkField() {
			this.shipmentID = ''
			this.manual = false
			this.status = ''
			this.ShipmentStatusError = ''
			this.comments = ''
			this.ShipmentIDError = ''
			this.IsShipmentTable = false
			this.EmptyList = false
			this.bagNo = ''
			this.bagStatus = ''
			this.BagStatusError = ''
			this.ShoratgeShipmentList = []
		},
		onSubmit: function(event) {
			this.$validator.validateAll().then((result) => {
				if (!result) {
					return false;
				}
			}).catch(() => {
				console.log('errors exist', this.errors)
			});
		}
	}
}



// WEBPACK FOOTER //
// ./src/views/components/InscanOverageShortage/InscanShortageShipment/InscanShortageShipment.js